import { render } from "./SaboresRestantes.vue?vue&type=template&id=55ea2bc0"
import script from "./SaboresRestantes.vue?vue&type=script&lang=js"
export * from "./SaboresRestantes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__